import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { isType } from '@sorare/core/src/lib/gql';

import { ThresholdsStreakTaskClaimStory } from 'components/missions/Streaks/ThresholdsStreakTaskClaimStory';

import { AnyTaskBasicClaimStory } from '../AnyTaskBasicClaimStory';
import { DecisivePlayerPickerTaskClaimStory } from '../DailyTask/DecisivePlayerPickerTaskClaimStory';
import { TaskTrckClaimStory } from '../TaskTrckClaimStory';
import type { AnyTaskClaimStory_taskInterface } from './__generated__/index.graphql';

type Props = {
  task: AnyTaskClaimStory_taskInterface;
  open?: boolean;
  onClose: () => void;
};
export const AnyTaskClaimStory = ({ task, open, onClose }: Props) => {
  if (!open) {
    return null;
  }

  if (isType(task, 'DecisivePlayerPickerTask')) {
    return task.parentTask ? (
      <TaskTrckClaimStory task={task} onClose={onClose} />
    ) : (
      <DecisivePlayerPickerTaskClaimStory task={task} onClose={onClose} />
    );
  }
  if (isType(task, 'ThresholdsStreakTask')) {
    return <ThresholdsStreakTaskClaimStory task={task} onClose={onClose} />;
  }

  return <AnyTaskBasicClaimStory task={task} onClose={onClose} />;
};

AnyTaskClaimStory.fragments = {
  taskInterface: gql`
    fragment AnyTaskClaimStory_taskInterface on TaskInterface {
      id
      ... on DecisivePlayerPickerTask {
        id
        parentTask {
          id
        }
      }
      ...DecisivePlayerPickerTaskClaimStory_decisivePlayerPickerTask
      ...ThresholdsStreakTaskClaimStory_thresholdsStreakTask
      ...AnyTaskBasicClaimStory_taskInterface
      ...TaskTrckClaimStory_decisivePlayerPickerTask
    }
    ${DecisivePlayerPickerTaskClaimStory.fragments.taskInterface}
    ${ThresholdsStreakTaskClaimStory.fragments.taskInterface}
    ${AnyTaskBasicClaimStory.fragments.taskInterface}
    ${TaskTrckClaimStory.fragments.taskInterface}
  ` as TypedDocumentNode<AnyTaskClaimStory_taskInterface>,
};
